import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { RtUIModule } from '../user-interface.module';
import { ZiggeoPlayerConfig } from './ziggeo-player-config';
import { ZiggeoPlayerComponent } from './ziggeo-player.component';

@NgModule({
  imports: [CommonModule, RtUIModule, ZiggeoPlayerComponent],
  exports: [ZiggeoPlayerComponent],
})
export class ZiggeoPlayerModule {
  public static forRoot(options: ZiggeoPlayerConfig): ModuleWithProviders<ZiggeoPlayerModule> {
    return {
      ngModule: ZiggeoPlayerModule,
      providers: [{ provide: ZiggeoPlayerConfig, useValue: options }],
    };
  }
}

export { ZiggeoPlayerComponent, ZiggeoPlayerConfig };
